'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.StopWatch = void 0;
var $ = require("jquery");
var StopWatch = /** @class */ (function () {
    function StopWatch() {
        var _this = this;
        this.elapsedTime = 0;
        this.lapTime = 0;
        this.timerToAdd = 0;
        this.rapNumber = 1;
        $('#trigStart').on('click', function (e) {
            var status = $(e.currentTarget).attr('data-status');
            if (status === 'start') {
                //在時刻を示すDate.nowを代入
                _this.startTime = Date.now();
                _this.startRapTime = Date.now();
                //再帰的に使えるように関数を作る
                _this.countUp();
                $(e.currentTarget).attr('data-status', 'stop');
            }
            else {
                _this.countStop();
                $(e.currentTarget).attr('data-status', 'start');
            }
        });
        $('#trigClear').on('click', function (e) {
            _this.clearTime();
        });
        $('#trigRap').on('click', function () {
            _this.recordRap();
        });
        $('.trigLeftBanner').on('click', function () {
            $('.bulletLeftBanner').hide();
        });
        $('.trigRightBanner').on('click', function () {
            $('.bulletRightBanner').hide();
        });
    }
    StopWatch.prototype.updateTimeText = function () {
        // h(時)
        var h = Math.floor(this.elapsedTime / 3600000);
        //m(分) = 135200 / 60000ミリ秒で割った数の商　-> 2分
        var m = Math.floor(this.elapsedTime % 3600000 / 60000);
        //s(秒) = 135200 % 60000ミリ秒で / 1000 (ミリ秒なので1000で割ってやる) -> 15秒
        var s = Math.floor(this.elapsedTime % 60000 / 1000);
        //ms(ミリ秒) = 135200ミリ秒を % 1000ミリ秒で割った数の余り
        var ms = this.elapsedTime % 1000;
        //HTML 上で表示の際の桁数を固定する　例）3 => 03　、 12 -> 012
        //javascriptでは文字列数列を連結すると文字列になる
        //文字列の末尾2桁を表示したいのでsliceで負の値(-2)引数で渡してやる。
        var hString = ('00' + h).slice(-2);
        var mString = ('00' + m).slice(-2);
        var sString = ('00' + s).slice(-2);
        var msString = ('000' + ms).slice(-3);
        //HTMLのid　timer部分に表示させる　
        $('#bulletTimer').html(hString + ':' + mString + ':' + sString + '<span>:' + msString + '</span>');
    };
    StopWatch.prototype.countUp = function () {
        var self = this;
        //timerId変数はsetTimeoutの返り値になるので代入する
        this.timerId = setTimeout(function () {
            //経過時刻は現在時刻をミリ秒で示すDate.now()からstartを押した時の時刻(startTime)を引く
            self.elapsedTime = Date.now() - self.startTime + self.timerToAdd;
            self.updateTimeText();
            //countUp関数自身を呼ぶことで10ミリ秒毎に以下の計算を始める
            self.countUp();
            //1秒以下の時間を表示するために10ミリ秒後に始めるよう宣言
        }, 10);
    };
    StopWatch.prototype.countStop = function () {
        //タイマーを止めるにはclearTimeoutを使う必要があり、そのためにはclearTimeoutの引数に渡すためのタイマーのidが必要
        clearTimeout(this.timerId);
        //タイマーに表示される時間elapsedTimeが現在時刻かたスタートボタンを押した時刻を引いたものなので、
        //タイマーを再開させたら0になってしまう。elapsedTime = Date.now - startTime
        //それを回避するためには過去のスタート時間からストップ時間までの経過時間を足してあげなければならない。elapsedTime = Date.now - startTime + timeToadd (timeToadd = ストップを押した時刻(Date.now)から直近のスタート時刻(startTime)を引く)
        this.timerToAdd += Date.now() - this.startTime;
    };
    // クリア処理
    StopWatch.prototype.clearTime = function () {
        $('#trigStart').attr('data-status', 'start');
        clearTimeout(this.timerId);
        // 経過時刻を更新するための変数elapsedTimeを0にしてあげつつ、updateTimetTextで0になったタイムを表示。
        this.elapsedTime = 0;
        //リセット時に0に初期化したいのでリセットを押した際に0を代入してあげる
        this.timerToAdd = 0;
        // ラップタイムもリセット
        this.lapTime = 0;
        //updateTimetTextで0になったタイムを表示
        this.updateTimeText();
    };
    //
    StopWatch.prototype.recordRap = function () {
        $('#bulletRap').show();
        // 経過時間を取得
        // ラップタイムの合計を取得（ラップタイムがないときは0）
        // 経過時間 - ラップタイム
        // 秒数を出す
        // ラップタイム
        var rapString = ('00' + this.rapNumber).slice(-2);
        this.rapNumber++;
        var time = this.elapsedTime - this.lapTime;
        var timeString = this.changeStringDate(time);
        var totalTimeString = this.changeStringDate(this.elapsedTime);
        var addHtml = "<tr class=\"timer__body\">\n                        <td>#" + rapString + "</td>\n                        <td>" + timeString + "</td>\n                        <td>" + totalTimeString + "</td>\n                    </tr>";
        /*

        const lapTime = Date.now() - this.startRapTime;
        this.startRapTime = Date.now();
        const lapTimeString = this.changeStringDate(lapTime);

        const elapsedTimeString = this.changeStringDate(this.elapsedTime);

        let addHtml = `<tr class="timer__body">
                        <td>#01</td>
                        <td>${lapTimeString}</td>
                        <td>${elapsedTimeString}</td>
                    </tr>`;
         */
        $('#bulletRap').append(addHtml);
        /*
        console.log(this.elapsedTime);
        clearTimeout(this.timerId);
        */
        this.lapTime = this.lapTime + time;
        /*
        $('body, html').delay(100).animate({
            scrollTop: $(document).height()
        },0);
        */
    };
    StopWatch.prototype.changeStringDate = function (date) {
        console.log(date);
        // h(時)
        var h = Math.floor(date / 3600000);
        //m(分) = 135200 / 60000ミリ秒で割った数の商　-> 2分
        var m = Math.floor(date % 3600000 / 60000);
        //s(秒) = 135200 % 60000ミリ秒で / 1000 (ミリ秒なので1000で割ってやる) -> 15秒
        var s = Math.floor(date % 60000 / 1000);
        //ms(ミリ秒) = 135200ミリ秒を % 1000ミリ秒で割った数の余り
        var ms = date % 1000;
        //HTML 上で表示の際の桁数を固定する　例）3 => 03　、 12 -> 012
        //javascriptでは文字列数列を連結すると文字列になる
        //文字列の末尾2桁を表示したいのでsliceで負の値(-2)引数で渡してやる。
        var hString = ('00' + h).slice(-2);
        var mString = ('00' + m).slice(-2);
        var sString = ('00' + s).slice(-2);
        var msString = ('000' + ms).slice(-3);
        var dateString = hString + ":" + mString + ":" + sString + ":" + msString;
        return dateString;
    };
    return StopWatch;
}());
exports.StopWatch = StopWatch;
exports.default = StopWatch;
